import Iframe from "@components/CustomTypography/Iframe/Iframe"
import NewResponsiveImage from "@components/CustomTypography/NewResponsiveImage/NewResponsiveImage"
import Paragraph from "@components/CustomTypography/Paragraph/Paragraph"
import Separator, {
	SeparatorType,
} from "@components/CustomTypography/Separator/Separator"
import ButtonComponent from "@components/Theme/Button/Button"
import {Translate} from "@components/Theme/Translate/Translate"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {direction} from "@customTypes/customTypes"
import formatDate from "@helpers/formatDate"
import {
	BlogPostModuleType,
	CategoryModuleType,
} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Link from "next/link"
import React from "react"

import CardsCategoryButton from "../CardsCategoryButton/CardsCategoryButton"

import styles from "./BlogVerticalCard.module.scss"

type Props = {
	data: BlogPostModuleType
	container?: SeparatorType
	minimalPost?: boolean
	direction: direction
}

const BlogVerticalCard = (props: Props): JSX.Element => {
	return (
		<Link
			className={`${styles.cardContainer} ${styles[props.direction]}`}
			href={props.data.link}
			rel={"noreferrer"}
		>
			{!props.minimalPost && (
				<div className={styles.assetContainer}>
					{props.data.thumbui.type === "image" && (
						<NewResponsiveImage
							{...props.data.thumbui}
							containerClassName={styles.imageContainer}
							imageClassName={styles.image}
							alt={props.data.title}
						/>
					)}
					{props.data.thumbui.type === "video" && (
						<Iframe {...props.data.thumbui} />
					)}
				</div>
			)}

			<div
				className={
					!props.minimalPost
						? styles.contentContainer
						: styles.contentContainerMinimal
				}
			>
				<Typography
					as={"h3"}
					className={styles.readMore}
					content={props.data.title}
					fontWeight={300}
					size={Size.L}
					variant={Variant.Title}
					noPadding
				/>

				<Typography
					content={
						<>
							<Translate capitalizeFirst>Posted on</Translate>:{" "}
							{formatDate(props.data.upperTitle)}
						</>
					}
					fontWeight={300}
					size={Size.XS}
					style={{
						textTransform: "uppercase",
					}}
				/>
				<Typography
					content={
						<>
							{props.data.category.map(
								(
									element: CategoryModuleType,
									index: number,
								) => {
									return (
										<React.Fragment key={index}>
											<CardsCategoryButton
												data={element}
												link={"newsArchive"}
												modifier={"category"}
												typograpyProps={{
													fontWeight: 300,
													style: {
														textTransform:
															"uppercase",
													},
												}}
											/>{" "}
											{index <
												props.data?.category?.length -
													1 && <>|</>}{" "}
										</React.Fragment>
									)
								},
							)}
						</>
					}
					fontWeight={300}
					size={Size.XS}
					style={{
						textTransform: "uppercase",
						display: "flex",
						alignItems: "center",
						gap: "3px",
					}}
				/>
				<Separator size={32} />
				<Typography
					content={props.data.content}
					truncate={400}
					variant={Variant.Description}
					stripHtml
				/>
				<Separator size={32} />
				<object>
					<ButtonComponent buttonType={"readMore"} asLink>
						<Translate> Read More </Translate>
					</ButtonComponent>
				</object>
			</div>
			{props.minimalPost && (
				<div className={styles.minimalAsset}>
					<Paragraph
						content={props.data.upperTitle}
						fontWeight={600}
						size={"M"}
					/>
				</div>
			)}
		</Link>
	)
}

export default BlogVerticalCard
